import React from "react";
import { Box, Title, createStyles } from "@mantine/core";
import { PieChart } from "react-chartkick";
import "chartkick/chart.js";

import TextBased from "./responses/TextBased.jsx";

const useStyles = createStyles((theme) => ({
  item: {
    borderRadius: theme.radius.md,
    border: `1px solid ${theme.colors.gray[4]}`,
    paddingTop: 15,
    paddingBottom: 15,
    paddingRight: 15,
    paddingLeft: 15,
    backgroundColor: theme.white,
    marginTop: 15,
    width: "100%",
  },
}));

export default function Summary(props) {
  const { classes } = useStyles();

  const countValuesFromChoices = (choices, question) => {
    const counts = {};
    const options = Array.isArray(question?.pod_member_filter?.options?.values)
      ? question.pod_member_filter.options.values
      : [];
    choices.forEach((choice) => {
      const values = choice.member_filter?.value;
      if (Array.isArray(values)) {
        values.forEach((val) => {
          const label = options.find((opt) => opt.value === val)?.name || val;
          counts[label] = (counts[label] || 0) + 1;
        });
      }
    });
  
    return Object.entries(counts);
  };

  return (
    <Box mt={20}>
      {Array.isArray(props.survey?.questions) && props.survey.questions.map((question) => {
        const choices = Array.isArray(question.choices) ? question.choices : [];
        const graph_data = Array.isArray(question.graph_data) ? question.graph_data : [];
        const graph_member_data = question.question_type == "member_property" ? countValuesFromChoices(choices, question) : [];
        return (
          <Box className={classes.item}>
            <Title order={5}>{question.content}</Title>
            {question.question_type == "freeform" ? (
              <>
                {choices.map((choice) => <TextBased response={choice.content} />)}
              </>
            ) : question.question_type == "member_property" ? (
              <>
                {["text", "number", "date", "location", "url"].includes(question.pod_member_filter?.format) ? choices.map(
                  (choice) => (
                    <TextBased
                      response={choice?.member_filter?.value}
                      format={question.pod_member_filter?.format}
                      options={question.pod_member_filter?.options}
                    />
                  )
                ) : graph_member_data.length > 0 ? (
                  <PieChart legend="bottom" data={graph_member_data} />
                ) : null}
              </>
            ) : graph_data.length > 0 ? (
              <PieChart legend="bottom" data={graph_data} />
            ) : null}
            {choices.length == 0 && <TextBased response="No response" />}
          </Box>
        );
      })}
    </Box>
  );
}
